/* -----------------Globals--------------- */
import { Text } from "react-native-paper";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import type { IconType } from "../../index";
/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import RenderMarkdown from "../MarkdownRenderer";

type FeedbackHeaderProps = {
	subtitle?: string;
	icon?: IconType;
	title?: string;
};

export const FeedbackHeader = ({
	title,
	subtitle,
	icon,
}: FeedbackHeaderProps) => {
	const theme = useAppTheme();

	return (
		<Box padding={24} gap={16} alignItems="center">
			<Icon name={icon} size={24} color={theme.colors.secondary} />
			<Text
				variant="headlineSmall"
				style={{ textAlign: "center", color: theme.colors.onSurface }}
			>
				{title}
			</Text>
			<RenderMarkdown
				text={subtitle}
				textAlign="center"
				customStyles={{
					text: {
						color: theme.colors.onSurfaceVariant,
					},
				}}
			/>
		</Box>
	);
};
